import React from 'react';
import { FieldValues } from '../IMSFormFieldsTypes';
import IMSFormAccordionItem from './IMSFormAccordionItem';
import { Group, Component } from '../imsFormTypes';

type IMSFormAccordionProps = {
  groups: Group[];
  fieldValues: FieldValues;
  handleFieldChange: (groupId: string | number, componentId: string | number, value: any, datatype: string) => void;
  shouldShowAutoPopulatedIndicator: (component: any, fieldValues: FieldValues) => boolean;
  setLightboxImage: (image: string | null) => void;
  setLightboxOpen: (open: boolean) => void;
};

const IMSFormAccordion: React.FC<IMSFormAccordionProps> = ({
  groups,
  fieldValues,
  handleFieldChange,
  shouldShowAutoPopulatedIndicator,
  setLightboxImage,
  setLightboxOpen,
}) => {
  
  return (
    <div>
      {groups.map((group) => (
        <IMSFormAccordionItem
          key={group.id}
          group={group}
          fieldValues={fieldValues}
          handleFieldChange={handleFieldChange}
          shouldShowAutoPopulatedIndicator={shouldShowAutoPopulatedIndicator}
          setLightboxImage={setLightboxImage}
          setLightboxOpen={setLightboxOpen}
        />
      ))}
    </div>
  );
};

export default IMSFormAccordion;
